<template>
    <div>
        <Header></Header>

        <section class="result-of-recommendation-area" :style="{ background:backgroundColor }">
            <div class="container-fluid" :class="isMobile() ? '':'px-5'">
                <div class="row">
                    <div class="col-md-12 padding-left-0">
                        <div class="result-of-recommendation-logo">
                            <img src="/koreyomo/static/assets/images/mai_image.png" alt="logo">
                            <p v-if="recommendWorksFromWorksData.maiResult" :style="{ color:textColor}">「{{recommendWorksFromWorksData.maiResult.personaText.toString()}}」さんにおすすめのマンガはコチラ！</p>
                        </div>
                    </div>
                </div>

                <div class="row"> 
                    <div :class="isIpad() ? 'col-md-12':'col-md-8'" :style="isMobile() ? 'line-height:0':''">
                        <div class="row recommendation">
                                <RecommendPanel v-bind:ranking-works="recommendWorksFromWorksData.rankingWorks"
                                            v-bind:persona-text="recommendWorksFromWorksData.maiResult ? recommendWorksFromWorksData.maiResult.personaText.toString() : '' "
                                            v-bind:work-info="recommendWorksFromWorksData.topWorkItem"
                                            v-bind:persona-id="recommendWorksFromWorksData.maiResult ? recommendWorksFromWorksData.maiResult.personaId : 0"
                                            v-bind:time-res="recommendWorksFromWorksData.maiResult ? recommendWorksFromWorksData.maiResult.timeRes : null"
                                            v-bind:restore-token="recommendWorksFromWorksData.restoreToken" />
                            </div>
                            <div class="row">
                                <div class="col text-center" :class="[(isMobile() ? 'mb-0 px-0 mt-0':'mt-2')]" :style="setHeight()">
                                     
                                     <router-link v-if="$route.query.m == 3" @click.native="sendAnalytics()" to="/" exact >
                                        <progressive-img :src="balloonImage" class="img-fluid" :style="isIpad() ? 'max-width: 100%;':''"/>
                                    </router-link>
                                     <progressive-img v-else :src="balloonImage" class="img-fluid" :style="isIpad() ? 'max-width: 100%;':''"/>
                                <div v-show="clearfix" class="clearfix"></div>
                                <div class="img-fluid progressive-image" :style="bottomImgStyle()">
                                    <div v-if="$route.query.m != 3" :style="isMobile() ? '':'text-align:right;margin-right:16px;'">
                                        <a :href="snsURL(shareText)" class="btn btn-social btn-twitter button1" style="left:0">
                                            <i class="fab fa-twitter"></i>ツイートする
                                        </a>
                                        <a href="javascript:" @click="snsFBURL(shareText)"  class="btn btn-social btn-facebook button2" style="left:0">
                                            <i class="fab fa-facebook-f"></i>シェアする
                                        </a>
                                    </div>
                                </div>
                                
                            </div>
                            </div>
                            
                        </div>
                    
                    <div id="slider" ref="slider" :style="sliderStyle()" class="col-md-4" :class="[(isMobile() ? 'px-0':'recommendation-right-side-padding'),(isIpad() ? 'col-md-12':'')]">

                        <h2 v-if="isMobile()" style="background: #4D4D4D;padding:10px 0px 10px 7px;font-size: 16px;border-bottom:1px solid #52576B;border-top:1px solid #000;border-left:1px solid #000;border-right:1px solid #000"><img  src="/koreyomo/static/assets/images/arrow_left.png" width="30" height="30" ><span @click="paramWorksThumbnailList($event)" class="header-back">{{actionText}}</span></h2>
                        <div class="recommendation-right" :style="stextColor()">
                            <p>あなたの今の気分は？</p>
                            <p class="margin-bottom-10">各スライダーを「今の気分」に合わせて みてください。</p>
                            <div class="slidecontainer mb-2">
                                    <span>楽しい</span> <span class="float-right">悲しい</span>
                                    <input @change="paramWorksThumbnailList($event)" @mouseup="paramWorksThumbnailListIE($event)"  type="range" min="0" max="10000" step="1" v-model="param1" class="slider-color" v-bind:style="sliderBackgroundColor">
                            </div>
                            
                            <div class="slidecontainer mb-2">
                                <span>コミカル</span> <span class="float-right">シリアス</span>
                                <input @change="paramWorksThumbnailList($event)" @mouseup="paramWorksThumbnailListIE($event)"  type="range" min="0" max="10000" step="1" v-model="param2"  class="slider-color" v-bind:style="sliderBackgroundColor">
                            </div>
                            <div class="slidecontainer mb-2">
                                <span>安心</span> <span class="float-right">不穏</span>
                                <input @change="paramWorksThumbnailList($event)" @mouseup="paramWorksThumbnailListIE($event)"  type="range"min="0" max="10000" step="1" v-model="param3"  class="slider-color" v-bind:style="sliderBackgroundColor">
                            </div>
                            <div class="slidecontainer mb-2">
                                <span>予想できる</span> <span class="float-right">予想できない</span>
                                <input @change="paramWorksThumbnailList($event)" @mouseup="paramWorksThumbnailListIE($event)"  type="range" min="0" max="10000" step="1" v-model="param4" class="slider-color" v-bind:style="sliderBackgroundColor">
                            </div>
                            <div class="slidecontainer mb-2">
                                <span>壮大な</span> <span class="float-right">身近な</span>
                                <input @change="paramWorksThumbnailList($event)" @mouseup="paramWorksThumbnailListIE($event)"  type="range"min="0" max="10000" step="1" v-model="param5"  class="slider-color" v-bind:style="sliderBackgroundColor">
                            </div>
                            <div class="slidecontainer mb-2">
                                <span>穏やか</span> <span class="float-right">暴力的</span>
                                <input @change="paramWorksThumbnailList($event)" @mouseup="paramWorksThumbnailListIE($event)"  type="range" min="0" max="10000" step="1" v-model="param6" class="slider-color" v-bind:style="sliderBackgroundColor">
                            </div>
                            <div class="slidecontainer mb-2">
                                <span>美しい</span> <span class="float-right">エグい</span>
                                <input @change="paramWorksThumbnailList($event)"  @mouseup="paramWorksThumbnailListIE($event)"  type="range" min="0" max="10000" step="1" v-model="param7"  class="slider-color" v-bind:style="sliderBackgroundColor">
                            </div>
                            <div class="slidecontainer mb-2">
                                <span>気軽に読める</span> <span class="float-right">しっかり読む必要</span>
                                <input @change="paramWorksThumbnailList($event)" @mouseup="paramWorksThumbnailListIE($event)"  type="range" min="0" max="10000" step="1" v-model="param8"  class="slider-color" v-bind:style="sliderBackgroundColor">
                            </div>
                            <div class="slidecontainer mb-2">
                                <span>型にはまった話</span> <span class="float-right">変わった話</span>
                                <input @change="paramWorksThumbnailList($event)" @mouseup="paramWorksThumbnailListIE($event)"  type="range" min="0" max="10000" step="1" v-model="param9" class="slider-color" v-bind:style="sliderBackgroundColor">
                            </div>
                            <div class="slidecontainer mb-2">
                                <span>明るい</span> <span class="float-right">ダーク</span>
                                <input @change="paramWorksThumbnailList($event)" @mouseup="paramWorksThumbnailListIE($event)"  type="range" min="0" max="10000" step="1" class="slider-color" v-model="param10" v-bind:style="sliderBackgroundColor">
                            </div>
                            <p class="margin-bottom-10" :style="{ color: textColor}"
                               >
                                マンガ人工知能MAIは、読者の感情を10 次元で認識して、「今の気持ち」に合い そうな作品をおすすめします。
                            </p>
                            <div v-if="isMobile()" class="slidecontainer my-4" style="text-align:center;">
                                <button @click="paramWorksThumbnailList($event)" class="btn btn-sm" style="background: #7997e0;border-radius: 22px;color:#fff;font-size: 16px;font-weight: normal;padding:3px 98px">{{actionText}}</button>
                            </div>
                            
                        </div>
                    </div>
                </div>

                <div class="row">
                     <h2 v-if="isMobile()" class="header pb-2 pt-2 pl-2 mb-0" style="font-size: 16px;width:100%;" :style="{background:visitedColor,color:textColor}">おすすめ作品を試し読み！</h2>
                </div>
               
                <div v-if="isMobile()"  class="px-0" :class="isIpad() ? 'col-md-12':'col-md-4'">
                        <div class="row" v-for="(item, index) in recommendWorksFromWorksData.rankingWorks" style="border-bottom:1px solid #ffffff;border-top:1px solid #ffffff;">
                            <div class="col-5 pl-0">
                                <a style="display:block; overflow: hidden;" href="javascript:void(0)" @click="sendAnalyticsManga($event)" :data-workname="item.workName" :data-workcode="item.workCode"><img class="img-fluid" height="100px" :src="item.bannerLargeImageUrl" alt="suggestion"/></a>
                            </div>
                            <div class="col-7 pl-0">
                                <p style="font-weight: bold;text-overflow: ellipsis;overflow: hidden;width:calc (80% - 0px);white-space: nowrap;" :style="{color:textColor}">{{item.workName}}</p>
                                <p style="text-overflow: ellipsis;overflow: hidden;width:calc (80% - 0px);white-space: nowrap;" :style="{color:textColor}">{{item.catchPhrase}}</p>
                                <a v-on:click="sendFeedback(item.workCode,recommendWorksFromWorksData.maiResult.timeRes, recommendWorksFromWorksData.maiResult.personaId,recommendWorksFromWorksData.restoreToken,recommendWorksFromWorksData.userId,$event)" style="color:#ffffff;border-radius:22px" :style="{position:'absolute',right:'10px',bottom:'8px',background:buttonColor,color:textColor}" class="btn btn-sm px-3 no-fadeout" :data-workname="item.workName">試し読み</a>
                            </div>
                        </div>
                    </div>
                
            </div>
        </section>

        <Footer></Footer>
        
    </div>
</template>

<script>
    import * as consts from '../constants';
    import Header  from "../components/Header";
    import Footer  from "../components/Footer";
    import * as Api from '../api/apies6.js';
    import RecommendPanel from "../components/RecommendPanel";
    window.axios = require('axios');

    export default {
        name: 'ResultOfRecommendation',
        computed: {
            platform: () => platform,
        },
        components:{
          RecommendPanel,
            Header,
            Footer
        },
        data () {
            return {
                recommendWorksFromWorksData:[],
                balloonImage: '',
                param1 : null,
                param2 : null,
                param3 : null,
                param4 : null,
                param5 : null,
                param6 : null,
                param7 : null,
                param8 : null,
                param9 : null,
                param10 : null,
                visitedColor : '#555',
                backgroundColor : '#000',
                textColor : '#fff',
                buttonColor : '#000',
                actionText:'結果に戻る',
                isChanged: false,
                shareText : '[Trend analysis catch] Manga',
                sliderBackgroundColor: '',
                sliderPointerColor: '',
                clearfix : false
            }
        },

        methods: {
            setHeight:function(){
                let mode = parseInt(this.$route.query.m)

                 if(!this.isMobile() && mode === 3){
                    return {
                        'min-height' : '160px'
                    } 
                 }else if(this.isMobile()){
                     return false
                 }else{
                      return {
                        'height' : '160px'
                    }  
                 }
            },
            
            /**
             * bottom image style
             * @returns {default.methods.bottomImgStyle.ResultOfRecommendationAnonym$3|default.methods.bottomImgStyle.ResultOfRecommendationAnonym$4|default.methods.bottomImgStyle.ResultOfRecommendationAnonym$5}
             */
            bottomImgStyle(){
                let mode = parseInt(this.$route.query.m)
                let position = 'absolute'
                if(mode == 3){
                   position = ''
                }
                if(this.isMobile()){
                    return {
                        'position' : position,
                        'text-align': 'center',
                        'bottom': '5%',
                        'left': '0',
                        'right' : '0',
                        'z-index' : '9'
                    }
                }else if(screen.width > 1500){
                    return {
                        'top': '-103px',
                        'max-width'  : '640px',
                        'bottom' : '0'
                    }
                }else{
                    return {
                          'max-width'  : '640px',
                          'bottom' : '64%'
                    }
                }
            },
            /**
             * send data to GA
             * @returns {undefined}
             */
            sendAnalytics: function(){
                this.gtagFunction(consts.HIT_TYPE.CLICK, consts.EVENT_CATEGORY.KOREYOMO,consts.EVENT_LABEL.RECOMMEND_PRE+document.title+consts.EVENT_LABEL.RECOMMEND_POST,this.$router.options.base);
            },
            sendAnalyticsManga: function(e){
                let workName = e.currentTarget.dataset.workname
                let workCode = e.currentTarget.dataset.workcode
                this.gtagFunction(consts.HIT_TYPE.CLICK, consts.EVENT_CATEGORY.KOREYOMO,consts.EVENT_LABEL.RECOMMEND_PRE+'_'+workName+consts.EVENT_LABEL.RECOMMEND_POST,this.getMangahotDetailUrl(workCode, this.recommendWorksFromWorksData.restoreToken, this.recommendWorksFromWorksData.maiResult.personaId, this.recommendWorksFromWorksData.maiResult.timeRes));
            },
            
            /**
             * text color of ride section
             * @returns {default.methods.stextColor.stlObject}
             */
            stextColor:function(){
                let stlObject = {
                    'color':this.textColor
                }
                if(this.isMobile()){
                    Object.assign(stlObject,{'padding':'0 16px 0 23px'});
                }
                return stlObject;
            },
            
            /**
             * send feedback to MAI server for mobile
             * @param {type} workCode
             * @param {type} timeRes
             * @param {type} personaId
             * @param {type} rt
             * @param {type} userId
             * @returns {undefined}
             */
            sendFeedback:function(workCode, timeRes, personaId,rt,userId,e){
                let workName = e.currentTarget.dataset.workname
                this.gtagFunction(consts.HIT_TYPE.CLICK, consts.EVENT_CATEGORY.KOREYOMO,consts.EVENT_LABEL.RECOMMEND_PRE+'_'+workName+consts.EVENT_LABEL.RECOMMEND_POST,'no');
                let api = new Api.KoreyomoApi(this.getApiConfig())
                api.feedbacksClickPost(workCode, timeRes, personaId,rt, userId)
            },
            
            /**
             * mobile slider stayle
             * @returns {default.methods.sliderStyle.ResultOfRecommendationAnonym$7}
             */
            sliderStyle:function(){
                if(this.isMobile()){
                    return {
                        'display': 'none',
                        'position':'fixed',
                        'z-index':'99999',
                        'top':'0',
                        'left' : '0',
                        'height':'100%',
                        'background': this.backgroundColor,
                        'overflow': 'scroll',
                        '-webkit-overflow-scrolling': 'touch'
                    }
                }
            },
            
            /**
             * set initial value of slider
             * @returns {undefined}
             */
            initParam:function(){
                this.param1 = this.recommendWorksFromWorksData.maiResult.param1*10000
                this.param2 = this.recommendWorksFromWorksData.maiResult.param2*10000
                this.param3 = this.recommendWorksFromWorksData.maiResult.param3*10000
                this.param4 = this.recommendWorksFromWorksData.maiResult.param4*10000
                this.param5 = this.recommendWorksFromWorksData.maiResult.param5*10000
                this.param6 = this.recommendWorksFromWorksData.maiResult.param6*10000
                this.param7 = this.recommendWorksFromWorksData.maiResult.param7*10000
                this.param8 = this.recommendWorksFromWorksData.maiResult.param8*10000
                this.param9 = this.recommendWorksFromWorksData.maiResult.param9*10000
                this.param10 = this.recommendWorksFromWorksData.maiResult.param10*10000
            },
            
            /**
             * set style & data for beginning
             * @returns {undefined}
             */
            initData:function(){
                this.visitedColor = this.recommendWorksFromWorksData.topWorkItem.visitedColor
                this.backgroundColor = this.recommendWorksFromWorksData.topWorkItem.backgroundColor
                this.textColor = this.recommendWorksFromWorksData.topWorkItem.textColor
                this.buttonColor = this.recommendWorksFromWorksData.topWorkItem.buttonColor
                
                document.title = 'コレヨモ！ - ' + this.recommendWorksFromWorksData.maiResult.personaText + 'さんへのおすすめマンガ';
                document.getElementsByTagName('meta')['description'].content = 'コレヨモ！は、マンガ人工知能MAIが読者の感情を10次元で認識して、今の気持ちに合いそうな作品をおすすめします。';
                
                this.shareText = '【' +this.recommendWorksFromWorksData.maiResult.personaText + '】' + ' さんにおすすめのマンガは 「'+this.recommendWorksFromWorksData.rankingWorks[0].workName+'」 あなたも診断してみる？ ⇒ '
                if(platform.name != 'IE' && platform.name != 'Microsoft Edge'){
                    this.sliderBackgroundColor = 'background:'+this.visitedColor
                }
                $("<style type='text/css'>"+
                ".slider-color::-webkit-slider-thumb{background:"+this.buttonColor+"}"+
                ".slider-color::-moz-range-thumb{background:"+this.buttonColor+"}"+
                 "@media all and (-ms-high-contrast:none){input[type=range]::-ms-thumb{background:"+this.buttonColor+"}}</style>").appendTo($("head"));

                $("<style type='text/css'>"+
                ".slider-color:active::-webkit-slider-thumb{background:"+this.textColor+
                "; -webkit-box-shadow: 0px 0px 6px 3px "+this.buttonColor+";"+
                "-moz-box-shadow: 0px 0px 6px 3px "+this.buttonColor+
                ";box-shadow: 0px 0px 6px 3px "+this.buttonColor+";}"+
                ".slider-color:active::-moz-range-thumb{background:"+this.textColor+
                ";-webkit-box-shadow: 0px 0px 6px 3px "+this.buttonColor+";"+
                "-moz-box-shadow: 0px 0px 6px 3px "+this.buttonColor+
                ";box-shadow: 0px 0px 6px 3px "+this.buttonColor+";}"+
                "@media all and (-ms-high-contrast:none){input[type=range]:active::-ms-thumb{background:"+this.textColor+";box-shadow: 0px 0px 13px 6px "+this.buttonColor+
                "}}</style>").appendTo($("head"));
        
                //set open graph meta
                $('meta[property=og\\:title]').attr('content', this.shareText);
                $('meta[property=og\\:url]').attr('content', window.location.host+this.$router.options.base+'recommend?m=3&rt='+this.$route.query.rt);
                $('meta[property=og\\:description]').attr('content', this.shareText);
            },
            
            /**
             * 
             * @param {type} workCodes
             * @returns {undefined}
             */
            worksThumbnailList: async function(workCodes) {
                let api = new Api.KoreyomoApi(this.getApiConfig())
                let recommendWorksFromWorks = await api.worksRecommendWorksFromWorksGetAsync(workCodes)
                this.recommendWorksFromWorksData = recommendWorksFromWorks;
                this.initParam()
                this.initData()
                
                let allImages = await api.mAIImagesGetAsync(this.isMobile())
                this.balloonImages = allImages['balloonImages'];
                this.balloonImage = this.balloonImages[Math.floor(Math.random() * this.balloonImages.length)]; 
                if (this.$cookies.isKey('topWorkID')) {
                    this.$cookies.remove('topWorkID');
                }
                this.$cookies.set('topWorkID', this.recommendWorksFromWorksData.topWorkItem.workCode, '10MIN');
                this.$cookies.set('personaId', this.recommendWorksFromWorksData.maiResult.personaId, '10MIN');
                this.$cookies.set('userId', this.recommendWorksFromWorksData.userId, '10MIN');
            },
            
	    paramWorksThumbnailListIE:async function(e) {
                if(platform.name != 'IE'){
                    return false;
                }
                if(e.type == 'change'){
                    this.isChanged = true;
                }
                if(e.target.nodeName == 'INPUT' && this.isMobile()){
                    this.actionText = '結果を見る';
                    return false;
                }
                if((e.target.nodeName == 'BUTTON' || e.target.nodeName == 'SPAN') && this.isMobile()){
                    $('body').css({'overflow':'','position':''});
                    $('#slider').hide('slide', { direction: 'down' }, 500);
                    if(!this.isChanged){
                        return false;
                    }
                }
                let api = new Api.KoreyomoApi(this.getApiConfig());
                let recommendWorksFromWorks = await api.worksRecommendWorksFromParametersGetAsync(this.$cookies.get('topWorkID'),Number(this.$cookies.get('personaId')),parseFloat(this.param1/10000),parseFloat(this.param2/10000),parseFloat(this.param3/10000),parseFloat(this.param4/10000),parseFloat(this.param5/10000),parseFloat(this.param6/10000),parseFloat(this.param7/10000),parseFloat(this.param8/10000),parseFloat(this.param9/10000),parseFloat(this.param10/10000),this.$cookies.get('userId'));
                this.recommendWorksFromWorksData = recommendWorksFromWorks;
                
                this.initData()
            },
            
	     paramWorksThumbnailList:async function(e) {
                if(platform.name == 'IE'){
                    return false;
                }
                if(e.type == 'change'){
                    this.isChanged = true;
                }
                if(e.target.nodeName == 'INPUT' && this.isMobile()){
                    this.actionText = '結果を見る';
                    return false;
                }
                if((e.target.nodeName == 'BUTTON' || e.target.nodeName == 'SPAN') && this.isMobile()){
                    $('body').css({'overflow':'','position':''});
                    $('#slider').hide('slide', { direction: 'down' }, 500);
                    if(!this.isChanged){
                        return false;
                    }
                }
                let api = new Api.KoreyomoApi(this.getApiConfig());
                let recommendWorksFromWorks = await api.worksRecommendWorksFromParametersGetAsync(this.$cookies.get('topWorkID'),Number(this.$cookies.get('personaId')),parseFloat(this.param1/10000),parseFloat(this.param2/10000),parseFloat(this.param3/10000),parseFloat(this.param4/10000),parseFloat(this.param5/10000),parseFloat(this.param6/10000),parseFloat(this.param7/10000),parseFloat(this.param8/10000),parseFloat(this.param9/10000),parseFloat(this.param10/10000),this.$cookies.get('userId'));
                this.recommendWorksFromWorksData = recommendWorksFromWorks;
                
                this.initData()
            },

	worksThumbnailListFromToken: async function(restoreToken) {
                let api = new Api.KoreyomoApi(this.getApiConfig())
                let recommendWorksFromWorks = await api.worksRecommendWorksFromTokenGetAsync(restoreToken)
                this.recommendWorksFromWorksData = recommendWorksFromWorks;
                let allImages = await api.mAIImagesGetAsync(this.isMobile())
                let bottomImage = 'balloonImages'
                let mode = parseInt(this.$route.query.m)
                if(mode === 3){
                    bottomImage = 'diagnosisBalloonImages'
                }
                this.balloonImages = allImages[bottomImage];
                this.balloonImage = this.balloonImages[Math.floor(Math.random() * this.balloonImages.length)]; 
                this.initParam()
                this.initData()
            }
        },

        created: async function () {
            let mode = parseInt(this.$route.query.m)
            if (mode === 1) {
                let workCode = this.$route.query.workCode
                this.worksThumbnailList(workCode)
            } else if (mode === 2) {
                let rt = this.$route.query.rt
                let timeres = this.$route.query.timeres
                let pid = this.$route.query.pid
                this.worksThumbnailListFromToken(rt)
            } else if (mode === 3) {
                let rt = this.$route.query.rt
                this.worksThumbnailListFromToken(rt)
            }
        },
        mounted:function(){
            if(this.isMobile()){
                $('#mai_image').show();
            }
            if(screen.width > 1500){
                this.clearfix = true
            }
        }
       
    }
</script>

<style>
    @media screen and (max-width:770px) {
        .header-content {
            display: none
        }
        .logo {
            float: none;
        }   
        header {
            text-align: center;
        }
        .recommendation-right-side-padding {
          padding-left: 0px;
        }
        .padding-left-0 {
            padding-left: 15px;
        }
       
    }

    #aiText p{
        position: relative;
        float: left;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%); 
    }

    .btn-social{
        position:relative;
        padding-left:44px;
        text-align:left;
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
        width:100%;
        max-width: 190px;
        
    }
    .btn-social :first-child{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 39px;
        line-height: 34px;
        font-size: 1.6em;
        text-align: center;
        border-right: 1px solid rgba(0,0,0,0.2);
        padding: 2px 6px;
    }
    .btn-facebook{
        color:#fff;
        background-color:#3764A2;
        border-radius: 40px;
    }
    .btn-facebook:hover,.btn-facebook:focus,.btn-facebook:active,.btn-facebook.active,.open .dropdown-toggle.btn-facebook{color:#fff;background-color:#3764A2;}

    .btn-twitter{color:#fff;background-color:#5EA9DD;border-radius: 40px;}
    .btn-twitter:hover,.btn-twitter:focus,.btn-twitter:active,.btn-twitter.active,.open .dropdown-toggle.btn-twitter{color:#fff;background-color:#5EA9DD;}
    .result-of-recommendation-area .btn.focus, .result-of-recommendation-area .btn:focus{
            box-shadow: none;
    }
    .result-of-recommendation-area .btn-social{
            max-width: 136px;
            padding-right: 6px;
            font-size: 14px;
    }
    
    @media only screen and (max-width: 1000px) {
        .result-of-recommendation-area .btn-social{
            max-width: 132px;
            font-size: 12px;
        }
    }

</style>


// WEBPACK FOOTER //
// src/pages/ResultOfRecommendation.vue